import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListCuratedContents from './list-curated-contents';
import CreateCuratedContent from './create-curated-content';
import CuratedContentDetail from './curated-content-detail';
import EditCuratedContent from './edit-curated-content';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';

const CuratedContentRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/list-curated-contents" element={<ListCuratedContents />} />
            <Route path="/create-curated-content" element={<CreateCuratedContent />} />
            <Route path="/curated-content-detail/:id" element={<CuratedContentDetail />} />
            <Route path="/edit-curated-content/:id" element={<EditCuratedContent />} />
            <Route path="/" element={<ListCuratedContents />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default CuratedContentRoutes;
